import type { VideoCardProps } from "@fdr/atomic-ui/_molecules/VideoCard";
import {
  HandicapSortOptionsType,
  RaceProgram,
  RaceWagerType
} from "@tvg/ts-types/Race";
import { BetStateType } from "@tvg/desktop-bet/src/types";
import { Actions } from "@fdr/shared-actions/ProgramPageActions";
import { Actions as BetActions } from "@tvg/shared-actions/BetActions";
import type { RaceBet } from "./types";

const resetArray = (matrix: string[][]): string[][] => matrix.map(() => []);

export type State = {
  currentRace: RaceProgram;
  trackRaces: RaceProgram[];
  showHeaderRaceNavigation: boolean;
  prevPath: string;
  betSelections: string[][];
  scratchedSelections: string[][];
  startBetting: boolean;
  showBetConfirmation: boolean;
  betState: BetStateType;
  betAmount: number;
  betType?: RaceWagerType;
  wagerTypes?: RaceWagerType[];
  betLeg: number;
  userSetHandicappingSortMode?: HandicapSortOptionsType;
  updatePicks: boolean;
  raceBets: Array<RaceBet>;
  pickEditButton: boolean;
  loadingRunners: boolean;
  isAllRunnersOpen: boolean[];
  selectedRunners: string[][];
  hasMultiLegWagers?: boolean;
  videoCarousel: {
    raceId: string;
    raceDate?: Date;
    videoCards: VideoCardProps[];
    lastFetchDate?: Date;
    title: string;
  };
};

export const initialState: State = {
  currentRace: {},
  trackRaces: [],
  showHeaderRaceNavigation: false,
  prevPath: "",
  betSelections: [[]],
  startBetting: false,
  showBetConfirmation: false,
  betState: "none",
  betAmount: 0,
  betType: undefined,
  betLeg: 0,
  pickEditButton: false,
  scratchedSelections: [[]],
  userSetHandicappingSortMode: HandicapSortOptionsType.ODDS,
  updatePicks: false,
  raceBets: [],
  loadingRunners: true,
  isAllRunnersOpen: [],
  selectedRunners: [[]],
  hasMultiLegWagers: undefined,
  videoCarousel: {
    raceId: "",
    raceDate: undefined,
    videoCards: [],
    lastFetchDate: undefined,
    title: ""
  },
  wagerTypes: []
};

export default function reducer(
  state: State = initialState,
  action: Actions | BetActions
): State {
  switch (action.type) {
    case "SET_CURRENT_RACE": {
      return {
        ...state,
        currentRace: action.payload
      };
    }
    case "SET_TRACK_RACES": {
      return {
        ...state,
        trackRaces: action.payload
      };
    }
    case "SHOW_HEADER_NAVIGATION": {
      return {
        ...state,
        showHeaderRaceNavigation: action.payload
      };
    }
    case "SET_PREVIOUS_PATH": {
      return {
        ...state,
        prevPath: action.payload
      };
    }
    case "SET_BET_CONFIRMATION": {
      return {
        ...state,
        showBetConfirmation: action.payload
      };
    }
    case "SET_START_BETTING": {
      return {
        ...state,
        startBetting: action.payload
      };
    }
    case "SET_BET_AMOUNT": {
      return {
        ...state,
        betAmount: action.payload
      };
    }
    case "SET_SELECTION_SCRATCHED": {
      return {
        ...state,
        scratchedSelections: action.payload
      };
    }
    case "SET_BET_TYPE": {
      return {
        ...state,
        betType: action.payload
      };
    }
    case "SET_WAGER_TYPES": {
      return {
        ...state,
        wagerTypes: action.payload
      };
    }
    case "SET_BET_SELECTIONS": {
      return {
        ...state,
        betSelections: action.payload
      };
    }
    case "SET_SELECTIONS_MATRIX": {
      return {
        ...state,
        betSelections: action.payload.selections
      };
    }
    case "RESET_BET_SELECTIONS": {
      return {
        ...state,
        betSelections: resetArray(state.betSelections),
        startBetting: false
      };
    }

    case "SET_PICK_EDIT_BUTTON": {
      return {
        ...state,
        pickEditButton: action.payload
      };
    }

    case "RESET_BETTING": {
      return {
        ...state,
        betSelections: [[]],
        startBetting: false,
        showBetConfirmation: false,
        betState: "none",
        betAmount: 0,
        betLeg: 0
      };
    }
    case "SET_BET_STATE": {
      return {
        ...state,
        betState: action.payload
      };
    }
    case "SET_PICK_LEG": {
      return {
        ...state,
        betLeg: action.payload
      };
    }
    case "USER_SET_HANDICAPPING_SORT_MODE": {
      return {
        ...state,
        userSetHandicappingSortMode: action.payload
      };
    }
    case "SET_RACE_BETS": {
      return {
        ...state,
        raceBets: action.payload
      };
    }

    case "SHOULD_UPDATE_PICKS": {
      return {
        ...state,
        updatePicks: action.payload
      };
    }

    case "SET_LOADING_RUNNERS": {
      return {
        ...state,
        loadingRunners: action.payload
      };
    }

    case "SET_OPEN_ALL_RUNNERS": {
      return {
        ...state,
        isAllRunnersOpen: action.payload
      };
    }

    case "SET_SELECTED_RUNNERS": {
      return {
        ...state,
        selectedRunners: action.payload
      };
    }

    case "SET_HAS_MULTI_LEG_WAGERS": {
      return {
        ...state,
        hasMultiLegWagers: action.payload
      };
    }

    case "SET_VIDEO_CAROUSEL": {
      return {
        ...state,
        videoCarousel: action.payload
      };
    }

    default: {
      return state;
    }
  }
}
